import { render, staticRenderFns } from "./projectProposal.vue?vue&type=template&id=05f77343&scoped=true&"
import script from "./projectProposal.vue?vue&type=script&lang=js&"
export * from "./projectProposal.vue?vue&type=script&lang=js&"
import style0 from "./projectProposal.vue?vue&type=style&index=0&id=05f77343&scoped=true&lang=css&"
import style1 from "./projectProposal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f77343",
  null
  
)

export default component.exports